import { useNavigate } from "react-router-dom";

import { useAuth } from "@/auth/AuthContext";
import { IconLogout } from "./Icon";

export function Topbar() {
  const auth = useAuth();
  const nav = useNavigate();

  async function handleLogout() {
    await auth.logout();
    nav("/login", { replace: true });
  }

  return (
    <header className="h-14 shrink-0 border-b border-line bg-bg-1 px-6 flex items-center justify-between">
      <div className="text-[12px] text-muted">
        Operatore:{" "}
        <span className="text-text-2">{auth.email ?? "—"}</span>
      </div>
      <button
        type="button"
        onClick={handleLogout}
        className="inline-flex items-center gap-1.5 text-[12px] text-text-2 hover:text-text transition-colors"
      >
        <IconLogout size={14} />
        Esci
      </button>
    </header>
  );
}
